import css from "standard/css";

const style = css`
  .class__container {
    display: flex;
    flex-direction: column;
    gap: var(--spacing_inset-nano);
  }

  .class__label {
    color: #6A6A6A;
    font-family: var(--font-family-base);
    font-size: var(--font-size-xs);
    font-weight: var(--font-weight-medium);
    line-height: var(--line-height-md);
  }
  
  .class__select {
    width: 100%;
    padding: 12px;
    background-color: transparent;
    border: var(--border-width-hairline) solid var(--color-master);
    border-radius: var(--border-radius-sm);
    font-size: 16px;
    color: #aaa;
    appearance: none;
    background-image: url('data:image/svg+xml;charset=US-ASCII,%3csvg%20xmlns%3d%22http://www.w3.org/2000/svg%22%20viewBox%3d%220%200%2010%206%22%3e%3cpath%20fill%3d%22%23666%22%20d%3d%22M0%200l5%205%205-5H0z%22/%3e%3c/svg%3e'); 
    background-repeat: no-repeat;
    background-position: right 12px center;
    background-size: 10px;
    cursor: pointer;

    option {
      background-color: white;
      color: #6A6A6A;
    }
  }
`;

export default style;
